import type { PropsWithChildren } from "react";
import { createContext, useContext, useEffect, useState } from "react";

import {
  createEmotionCache,
  defaultCache,
} from "~/features/style/emotion-cache";

import type { EmotionCache } from "@emotion/react";
import { CacheProvider } from "@emotion/react";

interface ClientStyleContextData {
  reset: () => void;
}

const ClientStyleContext = createContext<ClientStyleContextData | null>(null);

export const ClientStyleProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [cache, setCache] = useState(defaultCache);

  function reset() {
    setCache(createEmotionCache());
  }

  return (
    <ClientStyleContext.Provider value={{ reset }}>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </ClientStyleContext.Provider>
  );
};

export const useClientStyleReset = (emotionCache: EmotionCache) => {
  const clientStyleData = useContext(ClientStyleContext);

  // Only executed on client
  useEffect(() => {
    // re-link sheet container
    emotionCache.sheet.container = document.head;
    // re-inject tags
    const tags = emotionCache.sheet.tags;
    emotionCache.sheet.flush();
    tags.forEach((tag) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (emotionCache.sheet as any)._insertTag(tag);
    });
    // reset cache to reapply global styles
    clientStyleData?.reset();
    // We only want to execute this after the first render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
